import { action  } from "satcheljs";

const setSmartScheduleSelectedGroup = action(
    "SET_SMART_SCHEDULE_SELECTED_GROUP",
    (
        groupId: string
    ) => ({
        groupId
    })
);

export default setSmartScheduleSelectedGroup;